import React from 'react';
import { authRoles } from 'app/auth';

export const StudentActivityConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.instructor,
	routes: [
		{
			path: '/student-activity/:trainingId/:username',
			component: React.lazy(() => import('./StudentActivity'))
		},
		{
			path: '/student-activity/:trainingId',
			component: React.lazy(() => import('./StudentActivity'))
		},
		{
			path: '/student-activity',
			component: React.lazy(() => import('./StudentActivity'))
		}
	]
};
